import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appFocusFirstElement]'
})
export class FocusFirstElementDirective {

  constructor(private el: ElementRef) { }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      this.scrollTo(invalidElements[0]);
      invalidElements[0].focus();
    }
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

}
